import createCachedSelector from 're-reselect';
import { getPredictor } from '../getPredictor';

export const getSensorMappings = createCachedSelector(
  [getPredictor],
  predictor => predictor ? predictor.sensorMappings || [] : []
)(
  (state, chartType) => chartType
);